import React from 'react';
import './SignleProject.css'
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const SingleProject = (props) => {
    let {projctName, description, image, liveSite, id} = props.projects;
    return (
        <div>
            <div className="card mb-3 cardBg text-white shadow-lg">
            <div className="row g-0 d-flex align-items-center">
                <div className="col-md-4">
                <img src={image} className="img-fluid rounded-start" alt="..." />
                </div>
                <div className="col-md-8">
                <div className="card-body">
                    <h5 className="card-title  fw-bold border-bottom"> {projctName} </h5>
                    <p className='projectDes'> {description} </p>
                   <Link className='projectLink' to={`/project/${id}`}>
                    <Button variant="contained" color='primary'>View Details</Button>
                    </Link>
                    <a className='ms-3 projectLink' href={liveSite} target='_blank' rel="noopener noreferrer">  
                    <Button variant="contained" color='secondary'>Live Site</Button>
                    </a>
                </div>
                </div>
            </div>
            </div>
        </div>
       
    );
};

export default SingleProject;

